export const GET_HABILITATION_REQUEST = "GET_HABILITATION_REQUEST";
export const GET_HABILITATION_SUCCESS = "GET_HABILITATION_SUCCESS";
export const GET_HABILITATION_FAILLED = "GET_HABILITATION_FAILLED";

export const REFRESH_MISSIONS_LIST = "REFRESH_MISSIONS_LIST";

export const GET_RECIEPTS_REQUEST = "GET_RECIEPTS_REQUEST";
export const GET_RECIEPTS_SUCCESS = "GET_RECIEPTS_SUCCESS";
export const GET_RECIEPTS_FAILLED = "GET_RECIEPTS_FAILLED";
